import { AfterViewChecked, Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslocoService } from '@ngneat/transloco';
import { paremetersForRedirectUrl } from 'app/services/marketing/marketing-parameters';
import { MarketingGuestService } from 'app/services/marketing/marketing-guest.service';
import {Router} from '@angular/router'
import { switchMap } from 'rxjs';

@Component({
  selector: 'user-layout',
  templateUrl: './guest-layout.component.html',
  styleUrls: ['./guest-layout.component.scss']
})
export class GuestLayoutComponent implements OnInit, AfterViewChecked {

  switchLanguagePosition: | 'up' | 'down' = 'up';
  marketingSettings: any = paremetersForRedirectUrl['default'];
  showDotCom:boolean = true;

  constructor(
    private marketingGuestService: MarketingGuestService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.switchLanguagePosition = innerWidth <= 600 ? 'down' : 'up';
    this.marketingGuestService.setMarketingGuestDRedirectUrlata();
    this.marketingGuestService.marketingGuestDRedirectUrlata$.subscribe(data => {
      this.marketingSettings = data;
    })
  }

  ngAfterViewChecked(): void {
    // let languageSwitchEl = document.getElementsByClassName('p-speeddial')[0] as HTMLElement;
    // let languageSwitchPosition = languageSwitchEl.getBoundingClientRect().height + 20;
    // let languageSwitchComponent = document.getElementById('languageSwitchID') as HTMLElement;
    // languageSwitchComponent.style.bottom = languageSwitchPosition + 'px';
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.switchLanguagePosition = event.target.innerWidth <= 600 ? 'down' : 'up';
  }

  openCryptocom(){
    this.router.navigate(['/guest/sapphire-claim'])
  }

}